import {
  SHORTENER_RESOLUTION_CLEAR,
  SHORTENER_RESOLUTION_CLEAR_LINK_TO_RESOLVE,
  SHORTENER_RESOLUTION_FETCH_DOMAINS_SUCCESS,
  SHORTENER_RESOLUTION_SET_FILTERS_SELECTED,
} from '../../../../../actions/actionTypes';
import { getShortenerResolutionDomains } from '../../domains';

const defaultState = null;

const domain = (state = defaultState, action) => {
  switch (action.type) {
    case SHORTENER_RESOLUTION_SET_FILTERS_SELECTED:
      return action.payload.domain;
    case SHORTENER_RESOLUTION_CLEAR_LINK_TO_RESOLVE:
    case SHORTENER_RESOLUTION_CLEAR:
      return defaultState;
    case SHORTENER_RESOLUTION_FETCH_DOMAINS_SUCCESS: {
      const domains = getShortenerResolutionDomains(action.payload);
      return (
        domains.find(({ domainId }) => domainId === state?.domainId) ?? null
      );
    }

    default:
      return state;
  }
};

export default domain;
